import { render } from "./CardGatewayHealthChart.vue?vue&type=template&id=5519ff2a"
import script from "./CardGatewayHealthChart.vue?vue&type=script&lang=js"
export * from "./CardGatewayHealthChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__